import { dataTextSquare } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTextSquare = /*#__PURE__*/createIcon(dataTextSquare)
export default IconTextSquare
